import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import SabiasQue from "../SabiasQue";

// Template32: Página Día 3 - Arashiyama-2 (Mapa y contenido adicional) (Kioto)
// Contenido desde page.texts, page.images, page.canvasImages y page.maps (servidor).
const Template32 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
	onMapFullscreenChange,
}) => {
	const isSmallScreen = window.innerWidth <= 600;
	const [loaded, setLoaded] = useState(navigator.onLine);
	const [fullscreen, setFullscreen] = useState(false);
	const [isOnline, setIsOnline] = useState(navigator.onLine);

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const parseSabiasQueItem = (html) => {
		if (!html) return null;
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");
		const p = doc.querySelector("p");
		if (!p) return null;
		const text = (p.textContent ?? p.innerText ?? "").trim();
		const emojiMatch = text.match(/^([^\s]+)\s+(.*)/s);
		if (emojiMatch)
			return { icono: emojiMatch[1], texto: emojiMatch[2].trim() };
		return null;
	};

	const headerText = page?.texts?.[0]?.content;
	const tenryujiTitle = page?.texts?.[1]?.content;
	const tenryujiText = page?.texts?.[2]?.content;
	const monosTitle = page?.texts?.[3]?.content;
	const monosText = page?.texts?.[4]?.content;
	const extrasTitle = page?.texts?.[5]?.content;
	const sagaText = page?.texts?.[6]?.content;
	const adashinoText = page?.texts?.[7]?.content;
	const trenText = page?.texts?.[8]?.content;
	const sabiasQueTenryuji = parseSabiasQueItem(page?.texts?.[9]?.content);
	const sabiasQueMonos = parseSabiasQueItem(page?.texts?.[10]?.content);

	const mapUrl = page?.maps?.[0];
	const temploImage = getImageSrc("templo-arashiyama");
	const monosImage = getImageSrc("monos-arashiyama");
	const logoImage = getCanvasImageUrl("logo");
	const monosSticker = getCanvasImageUrl("monos-sticker");

	const contentColor = textColor || "#444";

	useEffect(() => {
		const handleOnline = () => {
			setIsOnline(true);
			setLoaded(true);
		};
		const handleOffline = () => {
			setIsOnline(false);
			setLoaded(true);
		};
		window.addEventListener("online", handleOnline);
		window.addEventListener("offline", handleOffline);
		return () => {
			window.removeEventListener("online", handleOnline);
			window.removeEventListener("offline", handleOffline);
		};
	}, []);

	useEffect(() => {
		const style = document.createElement("style");
		style.innerHTML = `
			@keyframes spin {
				0% { transform: rotate(0deg); }
				100% { transform: rotate(360deg); }
			}
		`;
		document.head.appendChild(style);
		return () => document.head.removeChild(style);
	}, []);

	if (fullscreen && mapUrl) {
		return (
			<Box
				sx={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "#fff",
					zIndex: 9999,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<Box
					sx={{
						padding: "10px",
						textAlign: "right",
						backgroundColor: "#5ba374",
					}}
				>
					<Box
						component="button"
						onClick={() => {
							setFullscreen(false);
							onMapFullscreenChange?.(false);
						}}
						sx={{
							backgroundColor: "#fff",
							color: "#5ba374",
							border: "none",
							borderRadius: "8px",
							padding: "6px 12px",
							fontWeight: 600,
							cursor: "pointer",
							fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
						}}
					>
						← Volver a la guía
					</Box>
				</Box>
				<Box
					component="iframe"
					title="Mapa grande"
					src={mapUrl}
					width="100%"
					height="100%"
					sx={{ border: 0, flex: 1 }}
					allowFullScreen
					loading="lazy"
				/>
			</Box>
		);
	}

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
		fontSize: "13px",
		color: contentColor,
		margin: 0,
	};

	const cardContainer = {
		display: "flex",
		gap: "16px",
		padding: "0 12px",
		marginBottom: "16px",
		position: "relative",
	};

	const cardImage = {
		width: "40%",
		height: 100,
		objectFit: "cover",
		borderRadius: "12px",
	};

	const cardContent = { width: "60%" };

	const sabiasQueContainer = {
		position: "absolute",
		top: "40px",
		left: "33%",
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
				"& p": {
					marginTop: "0px !important",
					marginBottom: "0px !important",
				},
				"& .margin": {
					marginBottom: "8px !important",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: headerBackgroundColor || "#5ba374",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
					fontSize: "14px",
					fontWeight: 800,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1053,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="map" sx={{ flex: 1, marginTop: "-70px", position: "relative" }}>
				{!loaded && isOnline && (
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							height: "100%",
							position: "absolute",
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							zIndex: 1,
						}}
					>
						<Box
							sx={{
								width: 20,
								height: 20,
								border: "4px solid #ccc",
								borderTop: "4px solid #5ba374",
								borderRadius: "50%",
								animation: "spin 1s linear infinite",
							}}
						/>
					</Box>
				)}

				{isOnline && mapUrl && (
					<Box
						component="button"
						onClick={() => {
							setFullscreen(true);
							onMapFullscreenChange?.(true);
						}}
						sx={{
							position: "absolute",
							top: 80,
							right: 10,
							backgroundColor: "#5ba374",
							color: "#fff!important",
							padding: "8px 10px",
							fontSize: "11px",
							borderRadius: "8px",
							textDecoration: "none",
							fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
							boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",

							border: "none",
							cursor: "pointer",
						}}
					>
						Ver mapa grande
					</Box>
				)}

				{isOnline && mapUrl && (
					<Box
						component="iframe"
						title="Mapa Arashiyama"
						src={mapUrl}
						width="100%"
						height="375px"
						allowFullScreen=""
						loading="lazy"
						sx={{ border: 0 }}
						onLoad={() => setLoaded(true)}
					/>
				)}

				{monosSticker && (
					<Box
						component="img"
						src={monosSticker}
						alt="MonosSticker"
						sx={{
							width: 100,
							position: "absolute",
							bottom: "-10px",
							left: 0,
						}}
					/>
				)}
			</Box>

			{(tenryujiTitle || tenryujiText) && (
				<Box data-block-id="text-1" sx={cardContainer}>
					{temploImage && (
						<Box
							component="img"
							src={temploImage}
							alt="Templo"
							sx={cardImage}
						/>
					)}
					<Box sx={cardContent}>
						{tenryujiTitle && (
							<Box component="h3" sx={h3}>
								{tenryujiTitle}
							</Box>
						)}
						{tenryujiText && (
							<Box
								component="p"
								sx={{
									...p,
									margin: "0 !important",
									marginBottom: "0px !important",
								}}
							>
								{tenryujiText}
							</Box>
						)}
					</Box>
					{sabiasQueTenryuji && (
						<Box sx={sabiasQueContainer}>
							<SabiasQue
								icono={sabiasQueTenryuji.icono}
								texto={sabiasQueTenryuji.texto}
							/>
						</Box>
					)}
				</Box>
			)}

			{(monosTitle || monosText) && (
				<Box sx={cardContainer}>
					{monosImage && (
						<Box component="img" src={monosImage} alt="Monos" sx={cardImage} />
					)}
					<Box sx={cardContent}>
						{monosTitle && (
							<Box component="h3" sx={h3}>
								{monosTitle}
							</Box>
						)}
						{monosText && (
							<Box
								component="p"
								sx={{
									...p,
									margin: "0 !important",
									marginBottom: "0px !important",
								}}
							>
								{monosText}
							</Box>
						)}
					</Box>
					{sabiasQueMonos && (
						<Box sx={sabiasQueContainer}>
							<SabiasQue
								icono={sabiasQueMonos.icono}
								texto={sabiasQueMonos.texto}
							/>
						</Box>
					)}
				</Box>
			)}

			{extrasTitle && (
				<Box
					sx={{
						paddingLeft: "12px",
						paddingRight: "12px",
						paddingBottom: "12px",
					}}
				>
					<Box
						sx={{
							backgroundColor: "#d9e6de",
							border: "3px solid #5ba374",
							borderRadius: "12px",
							padding: "16px 16px",
							fontSize: "12px",
							fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
							color: "#333",
							width: "100%",
							position: "relative",
						}}
					>
						<Box
							component="h4"
							sx={{
								margin: 0,
								marginBottom: "8px",
								fontSize: "13px",
								fontWeight: 700,
								display: "flex",
								alignItems: "center",
								gap: "6px",
								color: "#5ba374!important",
								textTransform: "uppercase",
							}}
						>
							{extrasTitle}
						</Box>
						{sagaText && (
							<Box
								component="p"
								className="margin"
								sx={{
									marginTop: "6px",
									fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
									margin: "0 !important",
									marginBottom: "8px !important",
									"& p": {
										marginBottom: "8px !important",
									},
								}}
								dangerouslySetInnerHTML={{ __html: sagaText }}
							/>
						)}
						{adashinoText && (
							<Box
								component="p"
								className="margin"
								sx={{
									marginTop: "8px",
									fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
									margin: "0 !important",
									marginBottom: "8px !important",
									"& p": {
										marginBottom: "8px !important",
									},
								}}
								dangerouslySetInnerHTML={{ __html: adashinoText }}
							/>
						)}
						{trenText && (
							<Box
								component="p"
								sx={{
									marginTop: "8px",
									fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
									margin: "0 !important",
									marginBottom: "0px !important",
								}}
								dangerouslySetInnerHTML={{ __html: trenText }}
							/>
						)}
					</Box>
				</Box>
			)}
		</Box>
	);
};

Template32.thumbnail = "/images/template-1.png";

export default Template32;
